import * as types from 'constants/ActionTypes';
import { MODELS_URL } from 'constants/ApiConstants';

// DERIVATIVE
export const fetchDerivative = ({ modelId, code, params }) => ({
  type: types.FETCH_DERIVATIVE_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${MODELS_URL}/${modelId}/derivatives/${code}`,
      params,
    },
  },
  meta: {
    code,
    modelId,
  },
});

export const fetchDerivativeFailure = error => ({
  type: types.FETCH_DERIVATIVE_FAILURE,
  error,
});

export const fetchDerivativeSuccess = (derivative, modelId, derivativeCode) => ({
  type: types.FETCH_DERIVATIVE_SUCCESS,
  derivative,
  modelId,
  derivativeCode,
});
